module.exports = __webpack_public_path__ + "static/media/FDYaX_MVQB0MVOa.e8418e83.webp";